"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColorPickerInputRoot = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _formInputTheme = require("../../../textinput/styled/formInputTheme");
var _colorPickerTheme = require("../../colorPickerTheme");
const ColorPickerInputRoot = (0, _styled.default)("div")`
    position: relative;
    width: 200px;
    min-height: 40px;
    input {
        padding-right: ${_ref => {
  let {
    focusMode,
    isFocused,
    themeMode,
    validationState
  } = _ref;
  return _colorPickerTheme.colorPickerTheme.input.padding.right[(0, _formInputTheme.getStylingState)({
    validationState,
    isFocused,
    focusMode
  })](themeMode);
}};
        padding-left: ${_ref2 => {
  let {
    focusMode,
    isFocused,
    themeMode,
    validationState
  } = _ref2;
  return _colorPickerTheme.colorPickerTheme.input.padding.left[(0, _formInputTheme.getStylingState)({
    validationState,
    isFocused,
    focusMode
  })](themeMode);
}};
    }
`;
exports.ColorPickerInputRoot = ColorPickerInputRoot;
//# sourceMappingURL=ColorPickerInputRoot.js.map